export default __webpack_public_path__ + "static/media/installation_safari2.fffea48a.png";